import { EMOJI_TYPE } from "./types.js";
const pluginEmoji = (config) => {
  return {
    config: { ...config },
    type: EMOJI_TYPE
  };
};
export {
  pluginEmoji
};
//# sourceMappingURL=viewer.js.map
